import React from 'react';
import { useSelector } from 'react-redux';
import { tagOptionsSelector } from 'reducers/bot_tags_selector';
import { GeckoField, GECKO_CONSTS } from '../../ui';
import PropTypes from 'prop-types';

const BotTagSelect = ({
  value,
  onChange,
  multi = false,
  placeholder = 'Add a tag',
}) => {
  const botTagOptions = useSelector(tagOptionsSelector);
  const fieldType =
    multi === true
      ? GECKO_CONSTS.FIELD_TYPE_SELECT_MULTI
      : GECKO_CONSTS.FIELD_TYPE_SELECT;

  const field = {
    key: 'value',
    type: fieldType,
    placeholder: placeholder,
    options: botTagOptions,
  };

  const values = { value };

  const handler = (_key, newValue) => {
    onChange(newValue);
  };

  return (
    <div className="BotTagSelect">
      <GeckoField field={field} values={values} handler={handler} />
    </div>
  );
};

BotTagSelect.propTypes = {
  multi: PropTypes.bool,
  placeholder: PropTypes.string,
  value: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default BotTagSelect;
